<div class="row g-3 align-items-center">
  <div class="col-auto">
    <label for="fromDate" class="form-label">From</label>
    <input id="fromDate" type="text" class="form-control" [ngModel]="getDateFromLimit()" (ngModelChange)="setDateFromLimit($event)" />
  </div>

  <div class="col-auto">
    <label for="untilDate" class="form-label">Until</label>
    <input id="untilDate" type="text" class="form-control" [ngModel]="getDateUntilLimit()" (ngModelChange)="setDateUntilLimit($event)" />
  </div>
</div>


@if (fileInfos.length > 0) {
  <table class="table table-sm table-hover">
    <thead>
    <tr>
      <th>active</th>
      <th>file</th>
      <th>size</th>
      <th>start</th>
      <th>end</th>
      <th>color</th>
    </tr>
    </thead>
    <tbody>
    @for (fileInfo of fileInfos; track fileInfo.name) {
      <tr>
        <td (click)="toggleActive(fileInfo)">
          <input type="checkbox" [disabled]="true" [checked]="getActive(fileInfo)"/>
        </td>
        <td (click)="toggleActive(fileInfo)">{{fileInfo.name}}</td>
        <td (click)="toggleActive(fileInfo)">{{fileInfo.points}}</td>
        <td (click)="toggleActive(fileInfo)">{{fileInfo.startTime}}</td>
        <td (click)="toggleActive(fileInfo)">{{fileInfo.endTime}}</td>
        <td>
          <input type="color" [value]="getFileColor(fileInfo)" (change)="changeColor(fileInfo, $event.target.value, $event)"/>
          {{getFileColor(fileInfo)}}
        </td>
      </tr>
    }
    </tbody>
  </table>
}
